// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"23":"affiliate","177":"home","179":"main","757":"game","828":"emergency"}[chunkId] || chunkId) + "." + {"23":"5ef19320","107":"f52e304a","177":"a7179858","179":"e3080d74","757":"c3fb3bd6","828":"595e2603"}[chunkId] + ".js";
};